import { Company } from 'module/api/company/types';
import styled from 'styled-components';
import { AccountPeopleListGrid } from './grid/grid';
import { PeopleListPageParams } from '../utils/use-page-params';

const Wrapper = styled.div`
  padding: var(--spacing-03) var(--spacing-06);
  height: 100%;
`;

type Props = {
  pageParams: PeopleListPageParams;
  company: Company;
  clearSearch: VoidFunction;
};
export const AccountPeopleList = ({
  pageParams,
  company,
  clearSearch,
}: Props) => {
  return (
    <Wrapper>
      <AccountPeopleListGrid
        pageParams={pageParams}
        company={company}
        clearSearch={clearSearch}
      />
    </Wrapper>
  );
};
